<div class="tabs-container" #tabsContainer>
  <button
    *ngFor="let tab of currentTabs; let i = index"
    class="tab"
    [class.is-active]="tab.isActive"
    [class.nav-arrow]="tab?.isArrow"
    (click)="onTabClicked(tab)"
    [disabled]="tab.id.startsWith('placeholder')"
  >
    <img
      class="left-arrow"
      *ngIf="tab.id === 'left-arrow'"
      src="assets/icons/white_arrow_right.svg"
      alt="Left Arrow"
    />
    <img
      *ngIf="tab.id === 'right-arrow'"
      src="assets/icons/white_arrow_right.svg"
      alt="Right Arrow"
    />
    <span
      *ngIf="
        tab.id !== 'left-arrow' &&
        tab.id !== 'right-arrow' &&
        !tab.id.startsWith('placeholder')
      "
    >
      {{ tab.title }}
    </span>
  </button>
</div>
